export default __webpack_public_path__ + "assets/fonts/rouble-webfont-7a64436e.woff2";